import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DbService } from '../app/services/db.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss'],
})
export class PaymentSuccessComponent implements OnInit {

  constructor(
    private router: Router,
    private DBService: DbService
  ) { }



  ngOnInit() {

    console.log('update');
    let payload = new FormData();



    const now = new Date();
    const durationDays = parseInt(localStorage.getItem('duration') || '0', 10);
    const validUptoDate = new Date(now.getTime() + durationDays * 24 * 60 * 60 * 1000);

    payload.append('id', localStorage.getItem('id')?.toString() || '');
    payload.append('validupto', validUptoDate.toISOString().substring(0, 10));
    payload.append('plan', localStorage.getItem('plan')?.toString() || '');
    
    this.DBService.editmember(payload).subscribe((response: any) => {
      if (response && response?.status === 200) {
        this.router.navigate(['/home-page']);
      }
      else if (response && response?.data?.message == "") {
        this.router.navigate(['/home-page']);
      }
      else {
      }
    },
      error => {
      });

  }

}
